import { SetInitialPasswordScreen } from "@src/components/modules/auth/set-password";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { createFileRoute } from "@tanstack/react-router";

const SetPassword = () => {
  return (
    <>
      <NoIndexHead />
      <SetInitialPasswordScreen />
    </>
  );
};
export const Route = createFileRoute("/set-password")({
  component: SetPassword,
});
